function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgCameraFilled(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 43,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M21.247 24.28a6.023 6.023 0 100-12.045 6.023 6.023 0 000 12.046z",
    fill: props.color
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M37.81 6.212h-5.552c-.282 0-.632-.183-.905-.47L28.91 1.888a1.453 1.453 0 00-.129-.175C27.94.731 26.8.19 25.576.19h-8.658c-1.223 0-2.363.542-3.206 1.525-.047.055-.09.113-.129.175l-2.441 3.858c-.21.228-.503.47-.811.47v-.752a1.506 1.506 0 00-1.506-1.506H6.566A1.506 1.506 0 005.06 5.465v.753h-.376a4.522 4.522 0 00-4.517 4.517v18.063a4.522 4.522 0 004.517 4.517H37.81a4.522 4.522 0 004.518-4.517V10.73a4.522 4.522 0 00-4.518-4.517zm-16.563 21.08a9.035 9.035 0 119.035-9.034 9.045 9.045 0 01-9.035 9.034z",
    fill: props.color
  }));
}

export default SvgCameraFilled;